
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"47"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"Rectangle_7331","x":"0","y":"0","width":"50","height":"47","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1.5","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#96a0ab","flood-opacity":".29"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"id":"Group_21195","data-name":"Group 21195","transform":"translate(-1235.145 -64.84)"}},[_c('g',{attrs:{"id":"Group_21198","data-name":"Group 21198","transform":"translate(1253.929 80.877)"}},[_c('g',{attrs:{"id":"Group_21195-2","data-name":"Group 21195"}},[_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M0 9.717l4.562-4.858L0 0","fill":"none","stroke":"#5e7288","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2"}})]),_c('g',{attrs:{"id":"Group_21197","data-name":"Group 21197","transform":"translate(6.907)"}},[_c('path',{attrs:{"id":"Path_2-2","data-name":"Path 2","d":"M0 9.717l4.562-4.858L0 0","fill":"none","stroke":"#5e7288","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2"}})])])])])
          )
        }
      }
    